import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class LeaderBoard {
  constructor() {
    document
      .querySelector('#leaderboard #leaderBackBtn')
      .addEventListener('click', this.goBackToScore.bind(this));

    this.leaderData = null;
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'LeaderBoard') return false;

    document.querySelector('#leaderboard').classList.add('active');

    this.fetchLeaderData();
  }
  fetchLeaderData() {
    document.querySelector('#leaderboard .leader_sec').innerHTML = '';
    Global.serverObj.send(
      Global.URL_LEADER,
      this.onLeaderData.bind(this),
      null,
      {
        uniqID: Global.U_ID,
      }
    );
    // this.onLeaderData();
  }
  onLeaderData(v) {
    this.leaderData = JSON.parse(v);

    const userEntry = this.leaderData.user;
    const range = document.createRange();
    this.leaderData.top.forEach((entry, index) => {
      var fragment = range.createContextualFragment(
        `<div class='holder_container'>
        <div class="leader_holder ${
          userEntry && userEntry.rank == index + 1
            ? 'green'
            : index == 0
            ? 'green2'
            : ''
        }"> <div class="rank">#${
          index + 1
        }</div> <div class="name"> <div class="title">${entry.name
          .substr(0, Math.min(entry.name.length, 18))
          .toUpperCase()}</div>  </div> <div class="score">${
          entry.score
        }</div> <div class="holder_bg"></div> </div>
        </div>`
      );
      document.querySelector('#leaderboard .leader_sec').append(fragment);
    });
    if (userEntry && userEntry.rank > 5) {
      var fragment = range.createContextualFragment(
        `<div class='holder_container'><div class="leader_holder green"> <div class="rank">#${
          userEntry.rank
        }</div> <div class="name"> <div class="title">${userEntry.name.toUpperCase()}</div>  </div> <div class="score">${
          userEntry.score
        }</div> <div class="holder_bg"></div> </div></div>`
      );
      document.querySelector('#leaderboard .leader_sec').append(fragment);
    }
    gsap.delayedCall(0.1, () => {
      document.querySelector('#leaderboard').classList.add('active2');
    });
    this.animateScreen();
  }
  animateScreen() {
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#leaderboard .contents .title')
        .classList.add('active');
    });
    let entryTotal = 0.1;
    document
      .querySelectorAll('.holder_container')
      .forEach((container, index) => {
        entryTotal += 0.1;
        gsap.delayedCall((index + 1) * 0.1, () => {
          container.classList.add('active');
        });
        //container
      });
    gsap.delayedCall(entryTotal, () => {
      document.querySelector('#leaderboard .footer').classList.add('active');
    });
  }
  goBackToScore() {
    this.hideScreen();
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'leaderBackClick',
      uniqID: Global.U_ID,
    });
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Score',
        },
      },
    });
  }
  hideScreen() {
    document
      .querySelector('#leaderboard .contents .title')
      .classList.remove('active');
    document.querySelector('#leaderboard .footer').classList.remove('active');
    document.querySelector('#leaderboard').classList.remove('active');
  }
}
